import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { ApiKeyResponse, CreateApiKeyInput, CreateApiKeyResponse } from '@orion/contracts';
import { api } from '../../../lib/api-client.js';

export function useApiKeysQuery() {
  return useQuery({ queryKey: ['api-keys'], queryFn: () => api.get<ApiKeyResponse[]>('/admin/api-keys') });
}
export function useCreateApiKey() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateApiKeyInput) => api.post<CreateApiKeyResponse>('/admin/api-keys', input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['api-keys'] }),
  });
}
export function useRevokeApiKey() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete(`/admin/api-keys/${id}`),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['api-keys'] }),
  });
}
